import type { EventSeriesOrderData } from '@beat-venues/common-types';
import { create } from 'zustand';

interface TransactionState {
    transactions: EventSeriesOrderData[];
    setTransactions: (transactions: EventSeriesOrderData[]) => void;
    isPendingFuture: boolean;
    setIsPendingFuture: (isPending: boolean) => void;
}

export const useTransactionsStore = create<TransactionState>((set) => ({
    transactions: [],
    isPendingFuture: false,
    setTransactions: (transactions) => set({ transactions }),
    setIsPendingFuture: (isPendingFuture) => set({ isPendingFuture }),
}));
